// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"156":"6e328b93","731":"84954309"}[chunkId] + ".css";
};